<template lang="pug">
.error(v-if="!checkRestrictions('ex:shop')")
    Error(:message="null" :code="403")
PaginatedItemsWrapper(
    v-else-if="activeCms"
    scope="ex"
    type="shop_shipping_method"
    :items-paginated="itemsPaginated"
    router-path="shipping-method-form"
    :loading="loading"
    :show-add-button="checkRestrictions('settings', 'update')"
    v-on:updateLoading="updateLoading"
    v-on:fetchItems="fetchItemsMethod"
    v-on:defineActiveColumns="defineActiveColumns"
    v-on:defineFilterVisibility="defineFilterVisibility"
    v-on:defineItemsPerPage="defineItemsPerPage"
    v-on:defineCurrentPage="defineCurrentPage"
    v-on:defineFilterValue="defineFilterValue"
    v-on:defineSort="defineSort"
)
    template(v-slot:active="{ item }")
        el-switch(
            :value="item.active"
            :disabled="togglingActiveIds.includes(item.id) || !checkRestrictions('settings', 'update')"
            @click.native.stop
            @change="value => toggleActive(item, value)"
        )
</template>

<i18n>
{
    "de": {
        "An error occurred!": "Es ist ein Fehler aufgetreten!",
        "Shipping method could not be saved.": "Versandmethode konnte nicht gespeichert werden."
    }
}
</i18n>

<script>
import { checkRestrictions } from '@/helpers'
import pinia from '@/pinia';
import { useSetupStore, useShopShippingStore } from '@/stores'

import Error from '@/components/Error';
import PaginatedItemsWrapper from '@/components/PaginatedItemsWrapper';

export default {
    name: 'ShippingMethodsPaginated',
    data() {
        return {
            shippingStore: useShopShippingStore(pinia),
            togglingActiveIds: []
        }
    },
    components: {
        Error,
        PaginatedItemsWrapper,
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms;
        },
        itemsPaginated() {
            return this.shippingStore.itemsPaginated;
        },
        loading() {
            return this.shippingStore.loading;
        }
    },
    methods: {
        fetchItemsMethod() {
            this.shippingStore.fetchPaginatedItems(this.activeCms.shop.id, this.activeCms.id)
                .then(() => this.updateLoading(false))
                .catch(err => { console.log(err) });
        },
        checkRestrictions,
        updateLoading(value) {
            this.shippingStore.updateLoading(value);
        },
        defineActiveColumns(activeColumnKeys) {
            this.shippingStore.defineActiveColumns(activeColumnKeys);
        },
        defineFilterVisibility(value) {
            this.shippingStore.defineFilterVisibility(value);
        },
        defineItemsPerPage(perPage) {
            this.shippingStore.defineItemsPerPage(perPage);
        },
        defineCurrentPage(currentPage) {
            this.shippingStore.defineCurrentPage(currentPage);
        },
        defineFilterValue(payload) {
            this.shippingStore.defineFilterValue(payload);
        },
        defineSort(payload) {
            this.shippingStore.defineSorting(payload);
        },
        toggleActive(item, active) {
            const previous = item.active;
            item.active = active;
            this.togglingActiveIds.push(item.id);

            this.shippingStore.updateShippingMethodActive({ id: item.id, active })
                .catch(err => {
                    item.active = previous;

                    console.error(err);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Shipping method could not be saved.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.togglingActiveIds = this.togglingActiveIds.filter(id => id !== item.id);
                });
        }
    }
};
</script>

<style lang="sass" scoped>
.error
    display: flex
    justify-content: center
    min-height: 200px
</style>
